import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DevOpsPlaceholderCardComponent } from '../devops-placeholder-card/devops-placeholder-card.component';

@Component({
  selector: 'app-devops-builds-incidents',
  imports: [DevOpsPlaceholderCardComponent],
  templateUrl: './devops-builds-incidents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsBuildsIncidentsComponent {}
